<template>
    <div class="a-modal">
        <div class="popup__header">
            <span class="title title--sm popup__title"> {{ $lang('user.purchases.popup.title2') }}</span>
        </div>
        <form class="form" @submit.prevent="submit">
            <div class="popup__content">
                <div class="form__item form__item--inline">
                    <div class="a-modal__inner">
                        <span class="form__label">{{ $lang('user.purchases.popup.label') }}</span>
                        <el-popover v-model="errors.page_id.isError"
                                    trigger="manual"
                                    placement="top"
                                    width="300"
                                    popper-class="add__error-popover"
                                    :content="errors.page_id.message">
                            <el-select dusk="page" filterable class="a-modal"
                                       id="page_id"
                                       disabled
                                       v-model="form.page_id"
                                       required
                                       slot="reference"
                                       :class="{ 'add__error': errors.page_id.isError }"
                                       :placeholder="$lang('user.purchases.popup.select')"
                                       :loading-text="$lang('el-select.loading')"
                                       :noDataText="$lang('el-select.noDataText')"
                                       :noMatchText="$lang('el-select.noMatchText')"
                                       @focus="clearErrors">
                                <el-option v-for="item in pages"
                                           :key="item.id"
                                           :label="item.name"
                                           :value="item.id">
                                </el-option>
                            </el-select>
                        </el-popover>
                    </div>
                </div>
                <div class="form__item a-modal__big">
                    <span class="form__label">{{ $lang('user.purchases.popup.label2') }}</span>
                    <el-popover v-model="errors.email.isError"
                                trigger="manual"
                                placement="top"
                                width="300"
                                popper-class="add__error-popover"
                                :content="errors.email.message">
                        <el-input
                            id="email"
                            slot="reference"
                            :class="{ 'add__error': errors.email.isError }"
                            @focus="clearErrors"
                            placeholder="primer@primer.ru"
                            class="input input--big"
                            v-model="form.email"
                        />v-
                    </el-popover>
                </div>
                <div class="form__item a-modal__big">
                    <span class="form__label">{{ $lang('user.purchases.popup.label3') }}</span>
                    <el-popover v-model="errors.phone.isError"
                                trigger="manual"
                                placement="top"
                                width="300"
                                popper-class="add__error-popover"
                                :content="errors.phone.message">
                        <input-phone
                            id="phone"
                            slot="reference"
                            :class="{ 'add__error': errors.phone.isError }"
                            @focus="clearErrors"
                            class="input input--big"
                            v-model="form.phone"
                        />
                    </el-popover>
                </div>
            </div>
            <div class="popup__footer">
                <div>
                    <button dusk="buy-button" class="btn btn--middle btn--main-bg">{{ $lang('user.purchases.popup.button2') }}</button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import mixin from '../../../mixins/errors';
import validator from '../../../mixins/validator';
import InputPhone from "../../../components/InputPhone";
import Vue from "vue";

export default {
    name: "copyright",
    mixins: [mixin, validator],
    components: {InputPhone},
    data: () => ({
        form: {
            page_id: null,
            email: null,
            phone: null
        },
        pages: [],
        errors: {
            page_id: {
                isError: false,
                message: ''
            },
            email: {
                isError: false,
                message: ''
            },
            phone: {
                isError: false,
                message: ''
            },
        },
        rules: {
            page_id: [
                {required: true, message: Vue.prototype.$lang('user.purchases.popup.rule')},
            ],
            email: [
                {required: true, message: Vue.prototype.$lang('user.purchases.popup.rule2')},
            ],
            phone: [
                {required: true, message: Vue.prototype.$lang('user.purchases.popup.rule3')},
            ],
        },
        paymentTypes: window.laravel.paymentTypes,
    }),
    mounted() {
        const pageId = parseInt(this.$route.query.page) || null;

        this.$loading(Vue.prototype.$optionsLoading);

        this.getUserPages().then((response) => {
            this.pages = response.data;
        })
        .finally(() => {
            this.$loading({}).close();

            let pageNotExist = !this.pages.find(page => page.id === pageId)

            if (pageNotExist) {
                this.$router.history.push('/cabinet/purchases');
                return;
            }

            this.form.page_id = pageId;
        });

        this.form.email = (this.user.email) ? this.user.email : null;
        this.form.phone = (this.user.phone) ? this.user.phone : null;
    },
    computed: {
        ...mapState('auth', [
            'user',
        ]),
    },
    methods: {
        ...mapActions('cabinet', [
            'getUserPages',
            'sendQrcodeStone'
        ]),
        submit() {
            this.validate(() => {
                this.pay()
            }, {...this.form});
        },
        pay() {
            const params = new URLSearchParams({
                page_id: this.form.page_id,
                payment_type: window.laravel.paymentTypes.copyright,
                price: window.laravel.prices.copyright.price,
                email: this.form.email,
                phone: this.form.phone,
                copyright: true,
                locale: window.laravel.locale
            });

            this.$dataLayer.push({'event': 'redirectToPayProduct', 'title': 'Подготовка описания'});

            window.location.href = window.laravel.prefix + `/payment?${params.toString()}`;
        },
    }
}
</script>
